import React, {forwardRef} from 'react';
import './VideoBackground.css';
import { Fade } from 'react-awesome-reveal';

const VideoBackground = forwardRef((props,ref) => {
  const handleScrollToNextSlide = () => {
    const nextSlide = document.querySelector('.VideoBackground').nextElementSibling;
    if (nextSlide) {
      nextSlide.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="VideoBackground" id='home' ref={ref}>
      <div className="overlay"></div>
      {/* <video autoPlay muted loop id="background-video">
        <source src="lab1_06OjFokj.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video> */}
      <img src='backgoround-image-1.jpg' id='background-video'></img>
      <div className="content">
        <Fade direction='up' duration={1500} fraction={0.9} triggerOnce >
          <h1>SENSORYOMICS</h1>
          <p> We make the data sets on this site available for all to use. Our goals are to provide open access to data sets for our colleagues and interested scientists in adjacent fields. This will encourage rigor, reproducibility and collaboration across multiple disciplines. Additionally, we desire to encourage the public to browse our resources and explore our data. The discoveries we have made belong to all of us and here we present them.</p>
        </Fade>
      </div>
      <div className="arrow-container" onClick={handleScrollToNextSlide}>
        <Fade direction='up' duration={1200} delay={100} cascade={false} triggerOnce >

          <div className="learn-more">Learn more</div>
          <div className="down-arrow">
            <img className="down-arow" src="white-down-arrow-png.png"></img>
          </div>
        </Fade>

      </div>
    </div>
  );
});

export default VideoBackground;